<div>
    <ul class="nav nav-tabs nav-tabs-light">
        <li class="nav-item">
            <a class="nav-link" routerLinkActive="active" routerLink="/xtended-soc/xtended-soc" #navbarRouterLink="routerLinkActive"
            [attr.aria-current]="navbarRouterLink.isActive ? 'page': undefined">Xtended SOC</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLinkActive="active" routerLink="/xtended-soc/dashboard" #navbarRouterLink="routerLinkActive"
            [attr.aria-current]="navbarRouterLink.isActive ? 'page': undefined">{{ 'pages.cybersocxdr.menu.dashboard' | translate }}</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLinkActive="active" routerLink="/xtended-soc/sla" #navbarRouterLink="routerLinkActive"
            [attr.aria-current]="navbarRouterLink.isActive ? 'page': undefined">{{ 'pages.cybersocxdr.menu.sla' | translate }}</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLinkActive="active" routerLink="/xtended-soc/incidents" #navbarRouterLink="routerLinkActive"
            [attr.aria-current]="navbarRouterLink.isActive ? 'page': undefined">{{ 'pages.cybersocxdr.menu.incidents' | translate }}</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLinkActive="active" routerLink="/xtended-soc/4A3W" #navbarRouterLink="routerLinkActive"
            [attr.aria-current]="navbarRouterLink.isActive ? 'page': undefined">{{ 'pages.cybersocxdr.menu.4A3W' | translate }}</a>
        </li>
        <!-- Anonymous toggle -->
        <li class="ms-auto">
            <input [(ngModel)]="anonymousEnabled" (change)="handleAnonymousToggleChange($event)" type="checkbox" class="btn-check" name="icons" id="anonymous-toggle" autocomplete="off" >
            <label class="btn btn-icon" for="anonymous-toggle">
                <fa-icon [icon]="['fas', 'eye']" ></fa-icon>
                <span class="visually-hidden">Anonymous mode</span>
            </label>
        </li>
    </ul>
    
    <br>
</div>


